import styled from 'styled-components/macro';
export const HolidayOrderDetailWrapper = styled.div`
  width: 100%;
  .boxLeft {
  }
`;
